import { Icon } from '../../Atoms/Icon';
import { TextSpan } from '../../Atoms/Text';

interface DetailsLinkCTAProps {
  setIsFormOpen: (isFormOpen: boolean) => void;
}

export function DetailsLinkCTA({ setIsFormOpen }: DetailsLinkCTAProps) {
  return (
    <>
      <button
        className="flex items-center space-x-2"
        onClick={() => setIsFormOpen(true)}
        data-cy="new-link">
        <Icon type="plus" />
        <TextSpan
          size="sm14"
          color="indigo">
          New Link
        </TextSpan>
      </button>
    </>
  );
}
